export default {
  login: '/login',
  resetPassword: '/reset-password',
  verifyReset: '/verify-reset-password',
  setNewPassword: '/set-new-password',
  changePassword: '/change-password',
  verifyOtp: '/authenticate/verify-otp',

  // pages
  dashboard: '/pages/dashboard',
  users: '/pages/admin/users',
  institutions: '/pages/admin/institutions',
  countries: '/pages/admin/countries',
  branches: '/pages/admin/branches',
  roles: '/pages/admin/roles',
  roleFunctions: '/pages/admin/role-functions',
  information: '/pages/information',
  customer: '/pages/customer',
  admin: '/pages/admin/users',
  profile: '/pages/profile',
  requestPending: '/pages/request/pending',
  banks: '/pages/system/bank',
  devices: '/pages/device',
  categories: '/pages/system/category',
  products: '/pages/system/product',
  passwordReset: '/pages/customer/password/reset',
  pinReset: '/pages/customer/pin/reset',
  billers: '/pages/system/biller',
  customerLimits: '/pages/limit/customer-limit',
  globalLimits: '/pages/limit/global-limit',
  transactions: '/pages/transactions',
  ussdSessions: '/pages/ussd-sessions',
  auditReport: '/pages/admin/audit/report',
  loggedInCustomers: '/pages/logged-customers',
  customerAudit: '/pages/admin/customer-audit',

  appConfig: '/pages/system/app-config',
  transferRoutes: '/pages/system/transfer-routes',
  healthCheck: '/pages/system/health-check',
  insights: '/pages/insights',
  appRatings: '/pages/app-ratings',
};
